import { useState, useEffect } from "react";
import Sentry from "@similarweb/sentry-logger";

export const useExceededLimitation = (isLimitationExceededFunc: () => Promise<boolean>) => {
    const [isLimitationExceeded, setIsLimitationExceeded] = useState(false);

    useEffect(() => {
        const checkLimit = async () => {
            try {
                const isExceeded = await isLimitationExceededFunc();
                setIsLimitationExceeded(isExceeded);
            } catch (error) {
                Sentry.error(`Error checking limitation:`, error);
            }
        };

        checkLimit();
    }, []);

    return isLimitationExceeded;
};
